<svg [attr.width]="width" [attr.height]="height">
    <!-- Center color -->
    <circle [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" fill="#ffffff" id="radius" />
    <!-- Default color of ring -->
    <circle [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" fill="transparent" [attr.stroke-width]="stroke_width" stroke="#d1d1d1" />

    <!-- Progress -->
    <!-- The amount shown as 'filled' is the amount the ring fills, starting from right center (3 o' clock) -->
    <!-- 100% fill
    viewbox="0 0 300 300" >
     -->
    <circle *ngFor="let value of values; let i = index" [attr.transform]="circle_transform" fill="transparent" [attr.cx]="cx"
        [attr.cy]="cy" [attr.r]="r" fill="transparent" [attr.stroke-width]="stroke_width" [attr.stroke]="value.color" [attr.stroke-dasharray]="setDonuts(value.range, i).stroke_dash_array"
        [attr.stroke-dashoffset]="setDonuts(value.range, i).stroke_dash_offset" />

    <!--<foreignObject class="node" [attr.cx]="cx" [attr.cy]="cy" [attr.width]="width" [attr.height]="height">
        <ng-content></ng-content>
    </foreignObject>-->
<switch>
    <text text-anchor="middle">
      <tspan x="50%" y="40%" class="result-value">{{userValue}}</tspan>
      <tspan x="50%" y="50%" dy="24px" class="result-label">{{label}}</tspan>
      <tspan x="50%" y="60%" dy="24px" class="result-label">{{labelText}}</tspan>
    </text>
</switch>

</svg>
